import React from 'react';
import {
  GQLEditableArea,
  GQLEngraving,
  GQLEngravingType
} from '@jewelutions/core-crm-server-api-client-domain';
import EngravingSingleLetterDetails from './EngravingSingleLetterDetails';
import EngravingTextDetails from './EngravingTextDetails';
import EngravingSymbolDetails from './EngravingSymbolDetails';
import { GQLEngravingHelper } from '../../operations/helpers/GQLEngravingHelper';
import { GQLOperationBuilder } from '../../operations/GQLOperationBuilder';
import { LoadingSpinner } from '..';

interface IProps {
  editableAreas: GQLEditableArea[];
  engravings: GQLEngraving[];
}

const EngravingList: React.FC<IProps> = ({ editableAreas, engravings }: IProps) => {
  const engravingsAssets = GQLEngravingHelper.getEngravingAssets(engravings);

  const { data: fontsData, loading: fontsLoading } = GQLOperationBuilder.font.getFonts({
    fontIds: engravingsAssets.fontIds
  });

  const { data: symbolsData, loading: symbolsLoading } = GQLOperationBuilder.symbol.getSymbols({
    symbolIds: engravingsAssets.symbolIds
  });

  if (fontsLoading || symbolsLoading) return <LoadingSpinner />;

  const fonts = GQLOperationBuilder.font.fontAssetArrayFromResponse(fontsData).map(f => f.font);
  const symbols = GQLOperationBuilder.symbol.symbolAssetArrayFromResponse(symbolsData).map(f => f.symbol);

  return (
    <React.Fragment>
      {engravings.map(engraving => {
        const side = editableAreas.find(ea => ea.id === engraving.editableAreaId)!.side;
        switch (engraving.type) {
          case GQLEngravingType.SingleLetter:
            return (
              <EngravingSingleLetterDetails
                side={side}
                engraving={engraving.text!}
                font={fonts.find(f => f.id === engraving.text!.fontId)!}
                key={engraving.id}
              />
            );
          case GQLEngravingType.Text:
            return (
              <EngravingTextDetails
                side={side}
                engraving={engraving.text!}
                font={fonts.find(f => f.id === engraving.text!.fontId)!}
                key={engraving.id}
              />
            );
          case GQLEngravingType.Symbol:
            return (
              <EngravingSymbolDetails
                side={side}
                engraving={engraving.symbol!}
                symbol={symbols.find(s => s.id === engraving.symbol!.symbolId)!}
                key={engraving.id}
              />
            );
        }
      })}
    </React.Fragment>
  );
};

export default EngravingList;
